import { useWatch } from 'react-hook-form';
import { usePersonDocumentTypes } from 'shared/hooks/(wallets)/kyc/usePersonDocumentTypes';
import { z } from 'zod';

import { schema } from '../DetailsStep/DetailsStep.schema';

export const useDocumentTypes = () => {
    const country = useWatch<z.infer<typeof schema>, 'person.address.country'>({
        name: 'person.address.country',
    });

    return usePersonDocumentTypes(country);
};
